import type { FaireProductEntity } from "../../entity_types/product";

export const p_eqwjmjvuqm: FaireProductEntity = {
  token: "p_eqwjmjvuqm",
  type: "product",
  name: "Sunkist Watermelon Lemonade - 2/12/12OZ",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/2b8c7ed52ab956767a75f3c0d8add45832d5184f132751ff9ca14e1831a8598b.jpeg",
  galleryImageUrls: [],
  priceDollars: 22.35,
  description:
    "Refreshing fusion of watermelon and lemonade flavors. Two 12-pack cases of 12 oz cans.",
  tags: [],
  msrpDollars: 44.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:52.714Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
